module.exports = __webpack_public_path__ + "static/img/iStock-855635188_mod.fb6daea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iStock-855635188_mod.png
// module id = 1725
// module chunks = 5